import {useEffect} from 'react';
import './useBodyScrollLock.css';

const LOCK_CLASS = 'simms-date-picker-scroll-lock';

let lockCount = 0;
let pendingUnlockRaf1 = 0;
let pendingUnlockRaf2 = 0;

function applyLock() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
        '--simms-scrollbar-gutter',
        scrollbarWidth > 0 ? `${scrollbarWidth}px` : '0px',
    );
    document.documentElement.classList.add(LOCK_CLASS);
}

function releaseLock() {
    document.documentElement.classList.remove(LOCK_CLASS);
    document.documentElement.style.removeProperty('--simms-scrollbar-gutter');
}

function cancelPendingUnlock() {
    if (pendingUnlockRaf1) {
        cancelAnimationFrame(pendingUnlockRaf1);
        pendingUnlockRaf1 = 0;
    }
    if (pendingUnlockRaf2) {
        cancelAnimationFrame(pendingUnlockRaf2);
        pendingUnlockRaf2 = 0;
    }
}

/** Popper가 DOM에서 빠진 뒤 잠금 해제 — 닫힐 때 스크롤바가 잠깐/계속 보이는 현상 완화 */
function scheduleUnlock() {
    cancelPendingUnlock();
    pendingUnlockRaf1 = requestAnimationFrame(() => {
        pendingUnlockRaf1 = 0;
        pendingUnlockRaf2 = requestAnimationFrame(() => {
            pendingUnlockRaf2 = 0;
            if (lockCount <= 0) {
                lockCount = 0;
                releaseLock();
            }
        });
    });
}

/**
 * 팝업(데이트 피커 등) 열릴 때 document 스크롤·스크롤바로 인한 레이아웃 흔들림 방지.
 */
export function useBodyScrollLock(locked) {
    useEffect(() => {
        if (!locked) {
            return undefined;
        }

        cancelPendingUnlock();
        lockCount += 1;
        if (lockCount === 1) {
            applyLock();
        }

        return () => {
            lockCount -= 1;
            if (lockCount <= 0) {
                lockCount = 0;
                scheduleUnlock();
            }
        };
    }, [locked]);
}
